<template>
  <portlet :icon="'fal fa-handshake'" :title="'Bezoeken'">
    <template slot="portletBody">
      <div v-if="sortedVisits.length === 0" class="text-center text-muted py-4">
        Geen bezoeken gevonden.
      </div>
      <table v-else class="table table-hover visits-table">
        <thead>
          <tr>
            <th class="sortable" @click="toggleSort">
              Datum
              <i class="fal ml-1" :class="sortDesc ? 'fa-sort-amount-down' : 'fa-sort-amount-up'"></i>
            </th>
            <th>Bezocht door</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="visit in sortedVisits"
            :key="visit.id"
            :class="{ 'recent-visit': isRecent(visit) }"
          >
            <td>{{ visit.created_at | time-day }}</td>
            <td>{{ visit.user ? visit.user.firstname + ' ' + visit.user.lastname : '-' }}</td>
          </tr>
        </tbody>
      </table>
    </template>
  </portlet>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';

export default {
  props: ['customer', 'id'],
  data() {
    return {
      recentThresholdWeeks: 4,
      sortDesc: true
    };
  },
  computed: {
    ...mapGetters('customerContactMoments', ['getCustomerContactMoments']),
    visits() {
      return this.getCustomerContactMoments.filter(m => m.customerId === this.id);
    },
    sortedVisits() {
      return [...this.visits].sort((a, b) => {
        const dateA = a.created_at ? new Date(a.created_at).getTime() : 0;
        const dateB = b.created_at ? new Date(b.created_at).getTime() : 0;
        return this.sortDesc ? dateB - dateA : dateA - dateB;
      });
    }
  },
  methods: {
    toggleSort() {
      this.sortDesc = !this.sortDesc;
    },
    isRecent(visit) {
      if (!visit.created_at) return false;
      return moment().diff(moment(visit.created_at), 'weeks') < this.recentThresholdWeeks;
    }
  }
};
</script>

<style lang="scss" scoped>
.visits-table {
  th.sortable {
    cursor: pointer;
    user-select: none;

    &:hover {
      background-color: #f5f5f5;
    }
  }

  .recent-visit {
    background-color: #e6f7f7;

    &:hover {
      background-color: darken(#e6f7f7, 3%);
    }
  }


}
</style>
